module.exports = function () {
    const videos = document.querySelectorAll(".video-play");
    const videosLazy = document.querySelectorAll("video[data-lazy-src]");
    
    if ( videos.length > 0 ) {
        videos.forEach(section => {
            const video = section.querySelector("video");
            
            if ( video ) {
                const poster = section.querySelector(".video-play-poster");
                const button = section.querySelector(".video-play-button");

                if ( button ) {
                    button.addEventListener("click", () => {
                        poster?.remove();
                        video.setAttribute("src", video.dataset.src);
                        video.play();
                        button.remove();
                    })
                }
            }
        })
    }
    
    videosLazy.forEach(video => {
        const observe = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if ( entry.isIntersecting ) {
                    observe.unobserve(video);
                    video.setAttribute("src", video.dataset.lazySrc);
                    
                    if ( video.nextElementSibling && video.nextElementSibling.classList?.contains('video-play-poster') ) {
                        video.nextElementSibling.remove();
                    }
                }
            }
        })

        observe.observe(video);
    })
}